<template>
  <div
    class="lv-btn-list"
    :class="{'border-bottom': borderBottom,}"
  >
    <LvText h6 class="mb-8">{{ $t(title) }}</LvText>
    <DotLoading v-if="isLoading" />
    <div v-else ref="wrap" class="lv-btn-list__content-wrap">
      <div
        ref="content"
        class="lv-btn-list__btn-wrap"
        :class="{collapse: isActive.collapse, 'flex-col-under-md': flexColUnderMd}"
      >
        <LvBtn
          v-for="(btn, btnIndex) in btnList"
          :key="btnIndex"
          :big="big"
          :btn="btn"
          :value="value"
          :white="white"
          :aliceBlue="aliceBlue"
          :flexColUnderMd="flexColUnderMd"
          @click="$emit('click', $event)"
        />
      </div>
      <LvText
        v-if="_isShowChevron"
        h4
        blue
        class="lv-btn-list__icon-lg"
        @click="$_onCollapse()"
      ><i :class="_icon" /></LvText>
      <LvFlexBox v-if="_isShowChevron" class="lv-btn-list__icon-md">
        <LvText v-if="toggleText" remark blue bold>{{ $t(`${toggleText}`) }}</LvText>
        <LvText
          h4
          blue
          @click="$_onCollapse()"
        ><i :class="_icon" /></LvText>
      </LvFlexBox>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
    },
    title: {
      type: String,
    },
    btnList: {
      type: Array,
      required: true,
    },
    borderBottom: {
      type: Boolean,
      default: false,
    },
    collapsable: {
      type: Boolean,
      default: false,
    },
    toggleText: {
      type: String,
      default: '展開更多選項組合',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    aliceBlue: {
      type: Boolean,
      default: true,
    },
    white: {
      type: Boolean,
      default: false,
    },
    flexColUnderMd: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      width: {
        content: 0,
        wrap: 0
      },
      isActive: {
        collapse: true,
      },
    }
  },
  computed: {
    _isShowChevron() {
      if (!this.collapsable) return false;
      return this.width.content >= this.width.wrap - 1;
    },
    _icon() {
      return this.isActive.collapse
        ? 'icon-chevron-down'
        : 'icon-chevron-up';
    },
  },
  watch: {
    btnList: {
      handler() {
        this.$nextTick(() => {
          this.$_getContentWidth();
        });
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.collapsable) this.isActive.collapse = false;
    this.$nextTick(() => {
      this.$_getContentWidth();
    });
    window.addEventListener('resize', this.$_getContentWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_getContentWidth);
  },
  methods: {
    $_getContentWidth() {
      const wrap = this.$refs.wrap;
      const content = this.$refs.content;
      if (!wrap) return;
      this.width.wrap = wrap.offsetWidth;
      this.width.content = content.offsetWidth;
    },
    $_onCollapse() {
      this.isActive.collapse = !this.isActive.collapse;
    },
  }
}
</script>